<template>
  <svg
    :class="{
      'text-www-color-accent': true,
    }"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5_1041)">
      <path
        d="M11.9933 15.7412V14.242C11.9933 12.5872 10.6498 11.2437 8.99499 11.2437H4.49749C2.84267 11.2437 1.49916 12.5872 1.49916 14.242V15.7412"
        stroke="currentColor"
        stroke-width="1.42421"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.74791 5.24687C3.74791 6.90169 5.09142 8.2452 6.74624 8.2452C8.40107 8.2452 9.74458 6.90169 9.74458 5.24687C9.74458 3.59204 8.40107 2.24854 6.74624 2.24854C5.09142 2.24854 3.74791 3.59204 3.74791 5.24687H3.74791"
        stroke="currentColor"
        stroke-width="1.42421"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.4908 15.7412V14.2421C16.4898 12.8757 15.5651 11.6828 14.2421 11.3412M11.9933 2.34619C13.32 2.68588 14.248 3.88133 14.248 5.25083C14.248 6.62032 13.32 7.81577 11.9933 8.15546"
        stroke="currentColor"
        stroke-width="1.42421"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1041">
        <rect
          width="17.99"
          height="17.99"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
